import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDigitsOnly]',
  standalone: true,
})
export class DigitsOnlyDirective {
  @Input() appDigitsOnly: boolean = true;

  constructor(private el: ElementRef) {}

  @HostListener('input') onInputEvent() {
    if (this.appDigitsOnly) {
      this.el.nativeElement.value = this.el.nativeElement.value?.replace(
        /\D/g,
        '',
      );
    }
  }

  @HostListener('paste', ['$event']) onPasteEvent(event: ClipboardEvent) {
    if (this.appDigitsOnly) {
      event.preventDefault();
      const pastedText = (
        event.clipboardData || (window as any).clipboardData
      ).getData('text');
      this.el.nativeElement.value = pastedText?.replace(/\D/g, '') || '';
      const newevent = new Event('input', { bubbles: true });
      this.el.nativeElement.dispatchEvent(newevent);
    }
  }

  @HostListener('drop', ['$event']) onDropEvent(event: DragEvent) {
    if (this.appDigitsOnly) {
      event.preventDefault();
      const droppedText = event.dataTransfer?.getData('text');
      this.el.nativeElement.value = (droppedText || '')?.replace(/\D/g, '');
      const newevent = new Event('input', { bubbles: true });
      this.el.nativeElement.dispatchEvent(newevent);
    }
  }
}
